import { DEVICES } from '_constants';
import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  max-width: 90%;
  width: 100%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media ${DEVICES.laptopL} {
    max-width: 95%;
  }
`;

export const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #6b7280;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;

  &:hover {
    color: #374151;
  }
`;

export const ModalBody = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
`;

export const ChangesCount = styled.div`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 16px;
  font-weight: 500;
`;

export const NoChangesText = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #6b7280;
  font-size: 16px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e5e7eb;
  overflow: hidden;
`;

export const TableHeader = styled.thead`
  background-color: #f9fafb;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid #e5e7eb;
  }

  ${TableBody} &:hover {
    background-color: #f9fafb;
  }
`;

export const TableHeaderCell = styled.th`
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  color: #111827;
  border-bottom: 2px solid #e5e7eb;

  &:not(:last-child) {
    border-right: 1px solid #e5e7eb;
  }
`;

export const TableSubHeaderCell = styled.th`
  padding: 10px 16px;
  text-align: left;
  font-weight: 500;
  font-size: 13px;
  color: #374151;
  background-color: #f3f4f6;

  &:not(:last-child) {
    border-right: 1px solid #e5e7eb;
  }
`;

export const TableCell = styled.td`
  padding: 12px 16px;
  font-size: 13px;
  color: #374151;
  word-break: break-word;
  max-width: 300px;

  &:not(:last-child) {
    border-right: 1px solid #e5e7eb;
  }

  ${({ isUpdated }) =>
    isUpdated &&
    `
    background-color: #fef3c7;
    font-weight: 500;
    color: #92400e;
  `}
`;

export const ModalFooter = styled.div`
  padding: 16px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;

  button {
    width: 150px;
  }
`;

export const FieldLabel = styled.div`
  color: #6b7280;
`;

export const FieldName = styled.div`
  font-weight: 500;
  color: #111827;
  margin-top: 2px;
`;
